import getFormatMessage from '../../../../locales/get-format-message';
import {
  IAPIStudioInfo,
  IAPIStudioMemberHasPermissionItem,
} from '../../../../model/api-modules/studio';
import './style.scss';
import { QuestionCircleOutlined } from '@ant-design/icons';
import cashAmountIcon from '../../../../assets/svg/cash-amount.svg';
import debtCashIcon from '../../../../assets/svg/debt-cash.svg';
import freezeIcon from '../../../../assets/svg/freeze.svg';
import { Button, Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
import { IBillingAccountInfo } from '../../../../model/billing-center';
import { GetformatMoney } from './component/fomat-money';
import headerMessage from '../../../../assets/svg/header-message.svg';
import { CommonButton } from '../../../../components/button/main';
import { useState } from 'react';
import { BalanceWarnDrawer } from './balance-warn-drawer';
import { PermissionCheck } from '../../permission-check';
import { RbacRoleObjectKey } from '../../../../model';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
  readonly balanceList: IBillingAccountInfo | null;
  readonly members?: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
}

export const TotalBalanceComponent = (props: IProps) => {
  const { members } = props;
  const history = useHistory();
  const studioId = props.studioInfo.studio.StudioID;

  const [showWarnDrawer, setShowWarnDrawer] = useState<boolean>(false);
  const handleRechargeClick = () => {
    history.push(`/studio/${studioId}/fee/overview/recharge`);
  };
  const handleWithDrawalClick = () => {
    history.push(`/studio/${studioId}/fee/overview/withdrawal`);
  };
  const handleBalanceClick = () => {
    history.push(`/studio/${studioId}/fee/overview/transaction-details`);
  };

  return (
    <div className="overview-balance">
      <div className="overview-title">
        <span>{getFormatMessage('total_balance')}</span>
        <div className="balance-title-desc">
          <Tooltip
            title={getFormatMessage('account_money_desc')}
            // getPopupContainer={() => tooltipContainer}
            overlayClassName="edit-member-tooltip"
          >
            <QuestionCircleOutlined style={{ cursor: 'pointer' }} />
          </Tooltip>
        </div>
      </div>
      <div className="balance-content">
        <div className="balance-money">
          <GetformatMoney
            className="normal-balance-money"
            money={props.balanceList?.account_balance}
            isNegative={
              props.balanceList?.account_balance !== undefined &&
              Number(props.balanceList.account_balance) < 0
            }
          />
        </div>
        <div className="balance-btn">
          <PermissionCheck permissionKey={RbacRoleObjectKey.FeeCenterEdit}>
            <CommonButton
              className="balance-warn"
              onClick={() => setShowWarnDrawer(true)}
            >
              <img src={headerMessage} />
            </CommonButton>
          </PermissionCheck>

          <Tooltip
            title={getFormatMessage('just_support_bank_transfer')}
            // getPopupContainer={() => tooltipContainer}
            overlayClassName="edit-member-tooltip"
          >
            <Button
              className="gc-btn gc-btn-primary recharge-container"
              onClick={handleRechargeClick}
            >
              {getFormatMessage('recharge')}
            </Button>
          </Tooltip>
          <Button
            className="gc-btn gc-btn-default recharge-container withdrawal-container"
            onClick={handleWithDrawalClick}
          >
            {getFormatMessage('withdrawal')}
          </Button>
          <Button
            className="gc-btn gc-btn-default balance-container"
            onClick={handleBalanceClick}
          >
            {getFormatMessage('balance')}
          </Button>
        </div>
      </div>
      <div className="balance-info">
        <div className="balance-info-content">
          <div className="info-content-desc">
            <img src={cashAmountIcon} />
            {getFormatMessage('cash_amount')}
          </div>
          <div className="info-content-number">
            <GetformatMoney
              className="normal-balance-detail-money"
              money={props.balanceList?.account_cash}
            />
          </div>
        </div>
        <div className="balance-info-content">
          <span className="info-line"></span>
        </div>
        <div className="balance-info-content">
          <div className="info-content-desc">
            <img src={debtCashIcon} />
            {getFormatMessage('debt_cash')}
          </div>
          <div className="info-content-number">
            <GetformatMoney
              className="normal-balance-detail-money"
              money={props.balanceList?.account_debt}
            />
          </div>
        </div>
        <div className="balance-info-content">
          <span className="info-line"></span>
        </div>
        <div className="balance-info-content">
          <div className="info-content-desc">
            <img src={freezeIcon} />
            {getFormatMessage('freeze')}
          </div>
          <div className="info-content-number">
            <GetformatMoney
              className="normal-balance-detail-money"
              money={props.balanceList?.account_freeze}
            />
          </div>
        </div>
      </div>
      {showWarnDrawer && members && (
        <BalanceWarnDrawer
          studioId={studioId}
          members={members}
          onClose={() => setShowWarnDrawer(false)}
        />
      )}
    </div>
  );
};
